import BillingReducer from "./billing";
import CashSalesReducer from "./cash-sales";
import DeliveryOrderReducer from "./delivery-order";
import PaymentSellingReducer from "./payment-selling";
import ReportVisitReducer from "./report-visit";
import ReturnPriceReducer from "./return-price";
import ReturnSellingReducer from "./return-selling";
import SalesOrderReducer from "./sales-order";
import SalesTargetReducer from "./sales-target";
import SellingReducer from "./selling";
import SellingPriceReducer from "./selling-price";
import TargetAssignmentReducer from "./target-assignment";
import TaskReducer from "./task";
import VisitScheduleReducer from "./visit-schedule";

export default {
  billing: BillingReducer,
  cashSales: CashSalesReducer,
  deliveryOrder: DeliveryOrderReducer,
  paymentSelling: PaymentSellingReducer,
  reportVisit: ReportVisitReducer,
  returnPrice: ReturnPriceReducer,
  returnSelling: ReturnSellingReducer,
  salesorder: SalesOrderReducer,
  salesTarget: SalesTargetReducer,
  selling: SellingReducer,
  sellingPrice: SellingPriceReducer,
  targetAssignment: TargetAssignmentReducer,
  task: TaskReducer,
  visitSchedule: VisitScheduleReducer,
};
